import { UseQueryOptions } from '@tanstack/react-query';

import { Template } from 'domains/content/types';
import useQuery from 'hooks/useQuery';
import { CuredApiPaths } from 'models/enums';

import QueryKeys from './keys';

const useTemplates = (
    reactQueryOptions?: UseQueryOptions<Template[], Error>,
    axiosOptions?: { params?: { status?: string } }
) => {
    // Always filter by status=published,live
    const mergedAxiosOptions = {
        ...axiosOptions,
        params: {
            ...axiosOptions?.params,
            status: 'published,live',
        },
    };

    return useQuery<Template[]>(QueryKeys.TEMPLATES, CuredApiPaths.TEMPLATES, reactQueryOptions, mergedAxiosOptions);
};

export default useTemplates;
